import React, { useState } from 'react';

const RegistrationPage = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    fatherName: '',
    grandfatherName: '',
    sex: '',
    educationLevel: '',
    dateOfBirth: '',
    region: '',
    city: '',
    fieldOfInterest: '',
    essayFile: null,
    email: '',
    phone: '',
  });

  const [errors, setErrors] = useState({});

  const regions = [
    'Addis Ababa', 'Afar', 'Amhara', 'Oromia', 'Tigray',
    'Southern Nations, Nationalities, and Peoples\' Region (SNNPR)'
  ];

  const citiesByRegion = {
    'Addis Ababa': ['Addis Ababa'],
    'Afar': ['Semera', 'Asayita'],
    'Amhara': ['Bahir Dar', 'Gondar', 'Dessie'],
    'Oromia': ['Adama', 'Jimma', 'Shashamane'],
    'Tigray': ['Mekelle', 'Adigrat', 'Shire'],
    'Southern Nations, Nationalities, and Peoples\' Region (SNNPR)': ['Hawassa', 'Arba Minch', 'Dilla'],
  };

  const validateForm = () => {
    const newErrors = {};
    // [Same validation logic as before...]
    if (!formData.firstName) newErrors.firstName = 'First name is required';
    if (!formData.fatherName) newErrors.fatherName = 'Father\'s name is required';
    if (!formData.grandfatherName) newErrors.grandfatherName = 'Grandfather\'s name is required';
    if (!formData.sex) newErrors.sex = 'Sex is required';
    if (!formData.educationLevel) newErrors.educationLevel = 'Education level is required';
    if (!formData.dateOfBirth) newErrors.dateOfBirth = 'Date of birth is required';
    if (!formData.region) newErrors.region = 'Region is required';
    if (!formData.city) newErrors.city = 'City is required';
    if (!formData.fieldOfInterest) newErrors.fieldOfInterest = 'Field of interest is required';
    if (!formData.essayFile) newErrors.essayFile = 'Essay file is required';
    if (!formData.email) newErrors.email = 'Email is required';
    if (!formData.phone) newErrors.phone = 'Phone number is required';

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (formData.email && !emailRegex.test(formData.email)) {
      newErrors.email = 'Invalid email format';
    }

    const fullPhone = `+251${formData.phone}`;
    const phoneRegex = /^\+251[97]\d{8}$/;
    if (formData.phone && !phoneRegex.test(fullPhone)) {
      newErrors.phone = 'Phone number must start with +2519 or +2517 and be 12 digits long in total';
    }

    if (formData.essayFile) {
      const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
      if (!allowedTypes.includes(formData.essayFile.type)) {
        newErrors.essayFile = 'Only PDF or Word files are allowed';
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData((prev) => ({ ...prev, essayFile: file }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      alert('Registration successful!');
      console.log(formData);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0b0f2a] to-[#0f1e45] flex items-center justify-center p-4">
      <style>
        {`
          @keyframes float {
            0% { transform: translateY(0px); }
            50% { transform: translateY(-10px); }
            100% { transform: translateY(0px); }
          }
        `}
      </style>

      <div className="flex bg-[#10192d] text-white shadow-2xl rounded-3xl overflow-hidden max-w-6xl w-full animate-fadeIn duration-700">
        {/* Left Side - Logo/Visual */}
        <div className="hidden md:flex w-1/2 flex-col items-start justify-start p-10 relative">
          <img
            src="./images/logo.png"
            alt="Logo"
            className="w-3/4 object-contain mt-2 mb-8 animate-[float_4s_ease-in-out_infinite]"
          />
        </div>

        {/* Right Side - Form */}
        <div className="w-full md:w-1/2 p-8 sm:p-10 animate-fadeIn">
          <h2 className="text-3xl font-bold mb-4">Register</h2>
          <p className="text-sm text-gray-300 mb-6">Welcome to the stars. Fill the form below and launch your journey.</p>

          <form onSubmit={handleSubmit} className="space-y-4">
            {['firstName', 'fatherName', 'grandfatherName'].map((field) => (
              <div key={field}>
                <input
                  type="text"
                  name={field}
                  placeholder={field.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
                  value={formData[field]}
                  onChange={handleChange}
                  className="w-full bg-[#1b2545] text-white border border-[#2a365c] px-4 py-3 rounded-lg focus:ring-2 focus:ring-blue-400 transition duration-300"
                />
                {errors[field] && <span className="text-red-400 text-sm">{errors[field]}</span>}
              </div>
            ))}

            {/* Dropdowns, Date, Region/City */}
            <select name="sex" value={formData.sex} onChange={handleChange}
              className="w-full bg-[#1b2545] text-white border border-[#2a365c] px-4 py-3 rounded-lg focus:ring-2 focus:ring-blue-400">
              <option value="">Select Sex</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
            </select>
            {errors.sex && <span className="text-red-400 text-sm">{errors.sex}</span>}

            <select name="educationLevel" value={formData.educationLevel} onChange={handleChange}
              className="w-full bg-[#1b2545] text-white border border-[#2a365c] px-4 py-3 rounded-lg focus:ring-2 focus:ring-blue-400">
              <option value="">Select Education Level</option>
              <option value="primary">Primary</option>
              <option value="high-school">High School</option>
              <option value="university-undergraduate">University Undergraduate</option>
              <option value="graduate">Graduate</option>
            </select>
            {errors.educationLevel && <span className="text-red-400 text-sm">{errors.educationLevel}</span>}

            <input type="date" name="dateOfBirth" value={formData.dateOfBirth} onChange={handleChange}
              className="w-full bg-[#1b2545] text-white border border-[#2a365c] px-4 py-3 rounded-lg" />
            {errors.dateOfBirth && <span className="text-red-400 text-sm">{errors.dateOfBirth}</span>}

            <select name="region" value={formData.region} onChange={handleChange}
              className="w-full bg-[#1b2545] text-white border border-[#2a365c] px-4 py-3 rounded-lg">
              <option value="">Select Region</option>
              {regions.map((region) => (
                <option key={region} value={region}>{region}</option>
              ))}
            </select>
            {errors.region && <span className="text-red-400 text-sm">{errors.region}</span>}

            <select name="city" value={formData.city} onChange={handleChange} disabled={!formData.region}
              className="w-full bg-[#1b2545] text-white border border-[#2a365c] px-4 py-3 rounded-lg">
              <option value="">Select City</option>
              {formData.region &&
                citiesByRegion[formData.region].map((city) => (
                  <option key={city} value={city}>{city}</option>
                ))}
            </select>
            {errors.city && <span className="text-red-400 text-sm">{errors.city}</span>}

            {/* Field of Interest */}
            <select name="fieldOfInterest" value={formData.fieldOfInterest} onChange={handleChange}
              className="w-full bg-[#1b2545] text-white border border-[#2a365c] px-4 py-3 rounded-lg">
              <option value="">Select Field of Interest</option>
              <option value="cybersecurity">Cybersecurity</option>
              <option value="development">Development</option>
              <option value="embedded-system">Embedded System</option>
              <option value="aerospace">Aerospace</option>
            </select>
            {errors.fieldOfInterest && <span className="text-red-400 text-sm">{errors.fieldOfInterest}</span>}

            {/* File Upload */}
            <div>
              <label className="text-gray-300 text-sm">Upload Essay</label>
              <input type="file" onChange={handleFileChange}
                className="w-full bg-[#1b2545] text-white border px-4 py-2 mt-1 rounded-lg file:bg-blue-500 file:text-white file:px-3 file:py-1 file:rounded-md hover:file:bg-blue-400" />
              {formData.essayFile && (
                <p className="text-sm text-gray-400 mt-1">Selected: {formData.essayFile.name}</p>
              )}
              {errors.essayFile && <span className="text-red-400 text-sm">{errors.essayFile}</span>}
            </div>

            {/* Email / Phone */}
            <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange}
              className="w-full bg-[#1b2545] text-white border px-4 py-3 rounded-lg" />
            {errors.email && <span className="text-red-400 text-sm">{errors.email}</span>}

            <div className="flex">
              <span className="bg-[#2a365c] px-4 py-3 rounded-l-lg border-r border-[#2a365c]">+251</span>
              <input type="tel" name="phone" placeholder="912345678" value={formData.phone} onChange={handleChange}
                className="w-full bg-[#1b2545] text-white border px-4 py-3 rounded-r-lg" />
            </div>
            {errors.phone && <span className="text-red-400 text-sm">{errors.phone}</span>}

            {/* Submit */}
            <button type="submit"
              className="w-full bg-blue-500 hover:bg-blue-400 transition duration-300 text-white font-bold py-3 rounded-lg">
              Sign Up
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RegistrationPage;
